export default __webpack_public_path__ + "static/media/ksivalue_medium.ec376981.jpg";